@if (iconMode() == 'url' && url()) {
  <img
    class="image"
    [class]="{ custom: size() == 'custom', md: size() == 'md' }"
    [attr.src]="url()" />
}

@if (iconMode() == 'icon' && icon()) {
  <app-icon [icon]="icon()" [size]="size()" />
}
